import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiUser, FiMail, FiLock, FiPhone, FiArrowLeft, FiUserPlus, FiBook } from 'react-icons/fi';
import './RegisterPMB.css';

const RegisterPMB = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    program_studi: '',
    jalur_pendaftaran: 'Reguler'
  });
  const [loading, setLoading] = useState(false);

  const programStudiOptions = [
    'Profesi Ners',
    'S1 Keperawatan',
    'S1 Kesehatan Masyarakat'
  ];

  const jalurPendaftaranOptions = [
    'Reguler',
    'Transfer',
    'RPL Transfer',
    'RPL Perolehan'
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      toast.error('Password tidak cocok');
      return;
    }

    if (!formData.program_studi) {
      toast.error('Pilih program studi');
      return;
    }

    setLoading(true);

    try {
      const { confirmPassword, ...registrationData } = formData;
      const res = await axios.post('/api/pmb/register', registrationData);
      
      toast.success(res.data.message);
      navigate('/pmb/login');
    } catch (error) {
      const message = error.response?.data?.message || 'Registrasi gagal';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-pmb-page">
      <div className="register-container">
        <Link to="/pmb" className="back-link">
          <FiArrowLeft /> Kembali ke Beranda
        </Link>

        <div className="register-content">
          <div className="register-header">
            <h1>Daftar Akun PMB</h1>
            <p>Lengkapi data diri Anda untuk memulai pendaftaran</p>
          </div>

          <form onSubmit={handleSubmit} className="register-form">
            <div className="form-section">
              <h3>Data Pribadi</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nama Lengkap <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiUser />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nama lengkap sesuai ijazah"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Email <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiMail />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@example.com"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Nomor Telepon <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiPhone />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="08xxxxxxxxxx"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Program Pilihan</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Program Studi <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiBook />
                    <select
                      name="program_studi"
                      value={formData.program_studi}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Pilih Program Studi</option>
                      {programStudiOptions.map(prodi => (
                        <option key={prodi} value={prodi}>{prodi}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Jalur Pendaftaran <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiBook />
                    <select
                      name="jalur_pendaftaran"
                      value={formData.jalur_pendaftaran}
                      onChange={handleChange}
                      required
                    >
                      {jalurPendaftaranOptions.map(jalur => (
                        <option key={jalur} value={jalur}>{jalur}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3>Keamanan Akun</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Password <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiLock />
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Minimal 6 karakter"
                      minLength="6"
                      required
                    />
                  </div>
                  <small>Gunakan kombinasi huruf, angka, dan simbol</small>
                </div>

                <div className="form-group">
                  <label>Konfirmasi Password <span className="required">*</span></label>
                  <div className="input-with-icon">
                    <FiLock />
                    <input
                      type="password"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      placeholder="Ulangi password"
                      minLength="6"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="form-agreement">
              <label className="checkbox-label">
                <input type="checkbox" required />
                <span>
                  Saya menyetujui <Link to="/pmb/terms">syarat dan ketentuan</Link> yang berlaku
                </span>
              </label>
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Mendaftar...' : (
                <>
                  <FiUserPlus /> Daftar Sekarang
                </>
              )}
            </button>

            <div className="form-footer">
              <p>Sudah punya akun? <Link to="/pmb/login">Login di sini</Link></p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPMB;
